import { ListViewInfos } from './list-view';

/* State path to the dashboard */

export const DashboardStatePath = 'dashboard';

/* Definition of dashboard core entity */

export type DashboardEntity = ListViewInfos;
